export default "__VITE_ASSET__B$lXftNz__"